import { XCircle, AlertTriangle } from 'lucide-react'
import type { Severity } from '@/utils/bundleFindings'

interface TrafficLightProps {
  severity: Severity | undefined
  className?: string
}

/**
 * P4.T9: small icon indicating finding severity on Composer card rows.
 * Returns null when severity is undefined — green is the absence of
 * any finding firing on this anchor (no icon clutter).
 */
export function TrafficLight({ severity, className = '' }: TrafficLightProps) {
  if (!severity) return null
  if (severity === 'error') {
    return (
      <XCircle
        role="img"
        aria-label="Error"
        className={`h-4 w-4 text-destructive inline-block ${className}`}
      />
    )
  }
  return (
    <AlertTriangle
      role="img"
      aria-label="Warning"
      className={`h-4 w-4 text-warning inline-block ${className}`}
    />
  )
}
